import React, {useEffect} from "react";
import classNames from "classnames";
import {CSelect} from "@coreui/react";
import {useController} from "react-hook-form";

const ARSelect = ({
                    name,
                    control,
                    className,
                    onSelectChange,
                    highlightInvalid,
                    options,
                    setError,
                    ...selectProps
                  }) => {
  const {
    field: {ref, onChange, onBlur, ...register},
    fieldState: {invalid, error}
  } = useController({name, control, shouldUnregister: true});

  useEffect(() => {
    setError && setError(error);
  }, [setError, error]);

  const changeHandler = (event) => {
    onChange(event);
    onSelectChange && onSelectChange(event.target.value);
  };
  return (
    <CSelect
      custom
      name={name}
      innerRef={ref}
      className={classNames("field_right-border-radius", className)}
      onChange={changeHandler}
      invalid={highlightInvalid ? invalid : null}
      // valid={highlightValid ? valid : null}
      {...register}
      {...selectProps}
    >
      {options.map((option) => <option key={option.value} value={option.value}>{option.name}</option>)}
    </CSelect>
  );
};

ARSelect.defaultProps = {
  highlightInvalid: false
};

export default ARSelect;